import axios from "axios";
import { store } from "store/store";
import AuthActions from "store/auth/actions";
import { showGlobalModal } from "utils/modalEmitter";

// URL da API: usa env ou fallback (produção vs localhost)
const getApiBaseUrl = () => {
  const url = process.env.REACT_APP_API_URL;
  if (url) return url;
  const isLocalhost =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
  return isLocalhost ? "http://localhost:8181" : "https://platform-api-v2-b4dtfmh9afhxb8cb.brazilsouth-01.azurewebsites.net";
};

const api = axios.create({
  baseURL: getApiBaseUrl()
});

// Interceptor de resposta para lidar com erros globais (401, 403)
api.interceptors.response.use(
  response => response,
  error => {
    // Não fazer logout automático ou exibir modal para endpoints específicos
    const protectedEndpoints = [
      "/logs/system-dashboard",
      "/admin/logs-dashboard",
      "/stripe/subscription/detail",
      "/plans/invoices",
      "/v2/stripe/plans",
      "/stripe/create-checkout-session",
      "/stripe/create-portal-session",
      "/users/login",
      "/users/register",
      "/users/verify-email",
      "/users/resend-verification",
      "/users/forgot-password",
      "/users/reset-password",
      "/transfers/"
    ];
    const isProtectedEndpoint = protectedEndpoints.some(endpoint =>
      error.config?.url?.includes(endpoint)
    );

    if (error.response) {
      const { status } = error.response;

      // Tratamento para erro 403 (Forbidden) - Assinatura/Permissão
      if (status === 403 && !isProtectedEndpoint) {
        const data = error.response?.data || {};
        const inner = typeof data.detail === "object" && data.detail !== null ? data.detail : data;
        const billingRequired = inner.code === "billing_required";
        const messageText =
          typeof data.detail === "string"
            ? data.detail
            : inner.message ||
              "Identificamos uma pendência na sua assinatura. Para continuar acessando este recurso, regularize sua conta.";
        showGlobalModal({
          variant: "warning",
          title: "Acesso Restrito",
          message: messageText,
          confirmText: billingRequired ? "Ver planos" : "Gerenciar Assinatura",
          cancelText: "Agora não",
          redirectOnConfirm: billingRequired ? "/plans" : "/subscriptions",
        });
        // Retorna uma promise rejeitada para que o componente local ainda possa saber que falhou, se necessário,
        // mas o modal já foi exibido.
        return Promise.reject(error);
      }

      // Tratamento para erro 401 (Unauthorized) - Token expirado/inválido
      if (status === 401 && !isProtectedEndpoint) {
        store.dispatch(AuthActions.logout());
      }
    }

    return Promise.reject(error);
  }
);

export default api;
